module.exports = __webpack_public_path__ + "static/media/29FUNOV11.71423795.jpg";